import React from 'react';

const Error = () => {
    return (
        <div className="access">
            Log in to access the meme generator
        </div>
    )
}

export default Error
